import { LinkWidget, Widget } from '../../../interfaces';

export function transformLinkWidget(widget: Widget): LinkWidget {
  return {
    title: widget.title || '',
    linkUrl: widget.link || '',
    linkText: widget.link_title || '',
    description: widget.description || '',
    imageUrl: widget.image_url || '',
    iconClass: '',
  };
}
